/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createProblemDetailsFromDiscriminatorValue, createSessionConsumptionEntryFromDiscriminatorValue, type ProblemDetails, type SessionConsumptionEntry } from '../../../../models/index.js';
// @ts-ignore
import { ExportRequestBuilderRequestsMetadata, type ExportRequestBuilder } from './exportEscaped/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type DateOnly, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /chargepoints/{id}/consumption/sessions
 */
export interface SessionsRequestBuilder extends BaseRequestBuilder<SessionsRequestBuilder> {
    /**
     * The export property
     */
    get exportEscaped(): ExportRequestBuilder;
    /**
     * GetChargePointSessionConsumptionEntries
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<SessionConsumptionEntry[]>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     get(requestConfiguration?: RequestConfiguration<SessionsRequestBuilderGetQueryParameters> | undefined) : Promise<SessionConsumptionEntry[] | undefined>;
    /**
     * GetChargePointSessionConsumptionEntries
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<SessionsRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
/**
 * GetChargePointSessionConsumptionEntries
 */
export interface SessionsRequestBuilderGetQueryParameters {
    from?: DateOnly;
    hasConsumption?: boolean;
    to?: DateOnly;
    top?: number;
}
/**
 * Uri template for the request builder.
 */
export const SessionsRequestBuilderUriTemplate = "{+baseurl}/chargepoints/{id}/consumption/sessions{?From*,HasConsumption*,To*,Top*}";
/**
 * Mapper for query parameters from symbol name to serialization name represented as a constant.
 */
const SessionsRequestBuilderGetQueryParametersMapper: Record<string, string> = {
    "from": "From",
    "hasConsumption": "HasConsumption",
    "to": "To",
    "top": "Top",
};
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const SessionsRequestBuilderNavigationMetadata: Record<Exclude<keyof SessionsRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    exportEscaped: {
        requestsMetadata: ExportRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const SessionsRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: SessionsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendCollection",
        responseBodyFactory:  createSessionConsumptionEntryFromDiscriminatorValue,
        queryParametersMapper: SessionsRequestBuilderGetQueryParametersMapper,
    },
};
/* tslint:enable */
/* eslint-enable */
